export function capitalizeFirstLetter(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function extractFirstSentence(text: string): string {
  if (!text) return text;
  return text.split(/[.!?]/)[0];
}
